module.exports = __webpack_public_path__ + "static/fig1-16987c014508f5e1d38cf9ccbf9133d5.jpg";